import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  getURL,
  GLOBAL_MANUFACTURERS_GET_BY_ID,
  GLOBAL_MANUFACTURERS_FOR_DROPDOWN,
} from 'lib/networking/endpoints';
import { httpGet } from 'lib/networking/http';
import SearchableScrollableSelect from 'components/shared/SearchableScrollableSelect';

function ManufacturerFilter({
  manufacturerId,
  manufacturerName,
  setAttributeValue,
  isGlobalProductAttribute,
  autoFocus,
  storeManufacturerId = false,
}) {
  const [initOption, setInitOption] = useState({});
  // initial load
  useEffect(() => {
    if (manufacturerId) {
      const url = getURL(GLOBAL_MANUFACTURERS_GET_BY_ID, { manufacturer_id: manufacturerId });
      httpGet(url).then(res => {
        if (res.status === 200) {
          const manufacturer = res.data?.manufacturer;
          if (manufacturer) {
            setInitOption({ label: manufacturer.name, value: manufacturer.id });
          }
        }
      });
    } else if (!storeManufacturerId && manufacturerName) {
      setInitOption({ label: manufacturerName, value: null });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SearchableScrollableSelect
      disabled={isGlobalProductAttribute}
      initOption={initOption}
      onChange={option =>
        storeManufacturerId
          ? setAttributeValue(option?.value ?? null)
          : setAttributeValue(option?.label)
      }
      fetchUrl={GLOBAL_MANUFACTURERS_FOR_DROPDOWN}
      optionMapper={manufacturer => ({ label: manufacturer.name, value: manufacturer.id })}
      autoFocus={autoFocus}
      allowCreate={!storeManufacturerId}
    />
  );
}

ManufacturerFilter.propTypes = {
  manufacturerId: PropTypes.number,
  manufacturerName: PropTypes.string,
  setAttributeValue: PropTypes.func,
  isGlobalProductAttribute: PropTypes.bool,
  autoFocus: PropTypes.bool,
  storeManufacturerId: PropTypes.bool,
};

export default ManufacturerFilter;
